<template>
  <div class="mainAuxPage zj-flex-column" style="padding:0 12px;">
    <div style="display: flex;flex: 4;margin-top: 7px;margin-bottom: 5px;">
      <teacherTopPage ref="teacherTopPage" v-if="isTeacher||isAdmin||isDeveloper"></teacherTopPage>
      <studentTopPage ref="studentTopPage" v-else></studentTopPage>
    </div>
    <div style="display: flex;flex: 3;margin-top: 7px;margin-bottom: 5px;">
      <mainBottomPage ref="mainBottomPage"></mainBottomPage>
    </div>

  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { mapGetters } from 'vuex';
  import vueQr from 'vue-qr';
  import mainBottomPage from './mainBottomPage';
  import studentTopPage from './studentTopPage';
  import teacherTopPage from './teacherTopPage';
  export default {
    components: {
      vueQr,
      teacherTopPage,
      studentTopPage,
      mainBottomPage
    },

    data () {
      return {

      };
    },
    computed: {
      ...mapState(["accountInfo"]),
      ...mapGetters(["isDeveloper", "isAdmin", 'isTeacher']),
    },
    methods: {

    },
    mounted () {
      console.log(this.isTeacher)
    }
  };
</script>

<style scoped>

</style>